"use strict";
/**
 * 向前兼容，内置四种语言包
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.translationMap = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
var zh_CN_1 = tslib_1.__importDefault(require("./locale/zh_CN"));
var en_US_1 = tslib_1.__importDefault(require("./locale/en_US"));
var ja_JP_1 = tslib_1.__importDefault(require("./locale/ja_JP"));
var ko_KR_1 = tslib_1.__importDefault(require("./locale/ko_KR"));
exports.translationMap = {
    zh_CN: zh_CN_1.default,
    zh: zh_CN_1.default,
    en_US: tslib_1.__assign(tslib_1.__assign({}, zh_CN_1.default), en_US_1.default),
    en: tslib_1.__assign(tslib_1.__assign({}, zh_CN_1.default), en_US_1.default),
    ja: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, zh_CN_1.default), en_US_1.default), ja_JP_1.default),
    jp: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, zh_CN_1.default), en_US_1.default), ja_JP_1.default),
    ko: tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, zh_CN_1.default), en_US_1.default), ko_KR_1.default),
};
/* eslint-enable */
//# sourceMappingURL=translationMap.js.map